import { render } from "./Enterprise_page.vue?vue&type=template&id=d2668bfe&scoped=true"
import script from "./Enterprise_page.vue?vue&type=script&lang=js"
export * from "./Enterprise_page.vue?vue&type=script&lang=js"

import "./Enterprise_page.vue?vue&type=style&index=0&id=d2668bfe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d2668bfe"

export default script